// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"53a8c459","453":"64e3b882","647":"467f77f0"}[chunkId] + ".chunk.js";
};